import { IconColor } from './iconsInterface'

export default function MicrophoneIcon({ color }: IconColor): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <path
        d="M600 0C268.63 0 0 268.64 0 600s268.63 600 600 600 600-268.62 600-600S931.37 0 600 0zM465.16 460.34v-99.72c0-85.7 60.36-155.17 134.83-155.17s134.84 69.47 134.84 155.17v217.82c0 85.68-60.36 136.82-134.84 136.82s-134.83-51.15-134.83-136.82v-118.1zm356.35 121.31c0 121.63-77.35 209.28-191.43 222.42v130.3h38.55c16.62 0 30.1 13.45 30.1 30.09s-13.48 30.1-30.1 30.1H531.38c-16.62 0-30.1-13.5-30.1-30.11s13.49-30.09 30.1-30.09h38.52V804.08c-114.07-13.14-191.43-100.8-191.43-222.42l1.62-116c.25-16.61 14.15-29.84 30.52-29.65 16.48.24 29.63 13.67 29.63 30.09 0 .14.04.28.04.42l-1.62 115.59c0 112.96 81.04 163.74 161.33 163.74s161.34-50.75 161.34-164.16v-115.6c0-16.63 13.48-30.1 30.1-30.1s30.09 13.46 30.09 30.1v115.56z"
        fill={color}
      />
    </svg>
  )
}
